<template>
  <ListpageMgr />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
